import { useEffect, useState } from "react";
import { cn } from "../../lib/utils";
import { bgMap, colorMap, ColorType, pureBgMap } from "../../shared/colors";
import { useInView } from "react-intersection-observer";

type LinearProgress2Props = {
  title: string;
  value: number;
  color: ColorType;
  pathWidth?: number;
};

const LinearProgress3 = ({
  title,
  value,
  color,
  pathWidth = 28,
}: LinearProgress2Props) => {
  const [counter, setCounter] = useState(0);
  const [done, setDone] = useState(false);
  const { ref: progressRef, inView: animate } = useInView();

  const startCount = () => {
    setDone(true);
    const interval = setInterval(() => {
      setCounter((p) => {
        const newCounter = p + 1;
        if (newCounter === value) {
          clearInterval(interval);
        }
        return newCounter;
      });
    }, 2000 / value);
  };

  useEffect(() => {
    if (animate && !done) {
      startCount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animate, done]);

  if (pathWidth < 24) pathWidth = 24;

  return (
    <div ref={progressRef} className="text-sm flex relative">
      <div
        className={cn("flex-1 rounded-e-sm relative", bgMap[color])}
        style={{ height: pathWidth }}
      >
        <div
          className={cn("absolute h-full rounded-e-sm", pureBgMap[color])}
          style={{
            transition: "2s ease-in-out",
            width: `${animate ? value : 0}%`,
          }}
        >
          <h3 className="absolute font-semibold left-2 top-[50%] translate-y-[-50%] text-[--title] ml-2 text-white">
            {title}
          </h3>
        </div>
      </div>
      <div className={cn("w-12  font-semibold", colorMap[color])}>
        <span className="absolute right-2 top-[50%] translate-y-[-50%]">
          {counter}%
        </span>
      </div>
    </div>
  );
};

export default LinearProgress3;
